import IMAGES from '../images'

export const newsBig = [
  {
    id: 1,
    title: null,
    desc: 'Sự kiện Card-Day: Thay đổi diện mạo - Kiến tạo thành công',
    link: 'https://www.vpbank.com.vn/tin-tuc/tin-vpbank/2023/card-day-sme',
    image: 'https://www.vpbank.com.vn/-/media/e45c96b18b814d63b378f3a291a761dd.png',
  },
  {
    id: 2,
    title: null,
    desc: 'Đặc quyền phòng chờ sân bay cho chủ thẻ VPBiz',
    link: 'https://www.vpbank.com.vn/uu-dai/sme/uu-dai-pcsb-danh-cho-chu-the-vpbiz',
    image: 'https://www.vpbank.com.vn/-/media/vpbank-latest/3sme/promotion/uu-dai-pcsb-cho-chu-the-vpbiz/1200x760_pcsb-cotext.png',
  },
]
export const newsSmall = [
  {
    id: 1,
    title: null,
    desc: 'VPBank tung ưu đãi hoàn tiền hấp dẫn từ bộ đôi thẻ doanh nghiệp',
    link: 'https://www.vpbank.com.vn/tin-tuc/thong-cao-bao-chi/2023/vpbank-tung-uu-dai-hoan-tien-hap-dan-tu-bo-doi-the-doanh-nghiep',
    image: 'https://www.vpbank.com.vn/-/media/67bca2785bf24e2582b79b096fdb6c06.png',
  },
  {
    id: 2,
    title: null,
    desc: 'VPBank ghi nhận thanh khoản dồi dào, tăng trưởng tín dụng chọn lọc, chốt ngày chia cổ tức tiền mặt',
    link: 'https://www.vpbank.com.vn/tin-tuc/thong-cao-bao-chi/2023/vpbank-cong-bo-bao-cao-tai-chinh-quy-iii-2023',
    image: 'https://www.vpbank.com.vn/-/media/083b5c4e764c4d069c103746b9c6e0dc.jpg',
  },
  {
    id: 3,
    title: null,
    desc: 'Tăng 32 bậc trong bảng xếp hạng Brand Finance, giá trị thương hiệu VPBank đạt gần 1,3 tỷ USD',
    link: 'https://www.vpbank.com.vn/tin-tuc/thong-cao-bao-chi/2023/vpbank-tang-32-bac-tren-bxh-brand-finance',
    image: 'https://www.vpbank.com.vn/-/media/2daac345644a4fd693dbec0dc21a5794.png',
  },
  {
    id: 4,
    title: null,
    desc: 'VPBank NEOBiz nhận giải ứng dụng ngân hàng tốt nhất dành cho SME, Micro SME',
    link: 'https://cafef.vn/vpbank-neobiz-nhan-giai-ung-dung-ngan-hang-tot-nhat-danh-cho-sme-micro-sme-188231107142730726.chn',
    image: 'https://cafefcdn.com/thumb_w/640/203337114487263232/2023/11/7/photo1699333172221-16993331723241955631916-16993420531181321125526.jpg',
  },
]
export const contacts = [
  {
    icon: IMAGES.MARKER,
    label: '89 Lang Ha str., Dong Da dist., Ha Noi',
    href: 'https://goo.gl/maps/aBDEhm7a4xSeajhn9',
    alt: 'marker',
  },
  {
    icon: IMAGES.PHONE,
    label: '1900 234 568',
    href: 'tel:1900234568',
    alt: 'phone',
  },
  {
    icon: IMAGES.MAIL,
    label: 'chamsocdoanhnghiep@vpbank.com.vn',
    href: 'mailto:chamsocdoanhnghiep@vpbank.com.vn',
    alt: 'mail',
  },
  {
    icon: IMAGES.FACEBOOK,
    label: 'facebook.com/vpbank.sme',
    href: 'https://facebook.com/vpbank.sme',
    alt: 'facebook',
  },
]
export const manageSale = [
  {
    id: 1,
    itemLabel: 'QUẢN TRỊ\nBÁN HÀNG\nTOÀN DIỆN',
    itemButton: 'Xem chi tiết',
    detailLabel: 'QUẢN TRỊ BÁN HÀNG TOÀN DIỆN',
    detailDesc: 'VPBank hợp tác cùng KiosViet/Sapo cung cấp gói giải pháp QUẢN TRỊ bán hàng toàn diện',
    detailList: [
      'Miễn phí 3 tháng sử dụng phần mềm quản lý bán hàng KioskViet/Sapo',
      'Tích hợp miễn phí cổng thanh toán Ecompay vào Website/App Mobile',
      'Hỗ trợ quản lý từ xa và đồng bộ hóa dữ liệu trên nhiều thiết bị',
    ],
  },
  {
    id: 2,
    itemLabel: 'QUẢN TRỊ\nTÀI CHÍNH\nLINH HOẠT',
    itemButton: 'Xem chi tiết',
    detailLabel: 'QUẢN TRỊ TÀI CHÍNH LINH HOẠT',
    detailDesc: 'Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod',
    detailList: [
      'Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod',
      'Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod',
      'Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod',
    ],
  },
  {
    id: 3,
    itemLabel: 'QUẢN TRỊ\nNHÂN SỰ\nDỄ DÀNG',
    itemButton: 'Xem chi tiết',
    detailLabel: 'QUẢN TRỊ NHÂN SỰ DỄ DÀNG',
    detailDesc: 'Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod',
    detailList: [
      'Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod',
      'Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod',
      'Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod',
    ],
  },
  {
    id: 4,
    itemLabel: 'QUẢN TRỊ\nTRUYỀN THÔNG\nHIỆU QUẢ',
    itemButton: 'Xem chi tiết',
    detailLabel: 'QUẢN TRỊ TRUYỀN THÔNG HIỆU QUẢ',
    detailDesc: 'Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod',
    detailList: [
      'Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod',
      'Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod',
      'Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod',
    ],
  },
]